var icons = require('../icons/caq-icons');

// Escape text for safe insertion into HTML (text nodes and double-quoted attrs).
function escapeCaqHtml(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

// One CAQ card: Q / A / "Read full answer" CTA. The question is stored on the
// CTA via data-question so the click handler can open the AI layer with it.
function caqCardMarkup(card) {
    var question = escapeCaqHtml(card.question);
    var answer = escapeCaqHtml(card.answer);

    return '<div class="card">' +
               '<div class="question">' +
                   '<span class="prefix">Q: </span>' +
                   '<span>' + question + '</span>' +
               '</div>' +
               '<div class="answer">' +
                   '<span class="prefix">A: </span>' +
                   '<span>' + answer + '</span>' +
               '</div>' +
               '<div class="cta" role="button" tabindex="0" aria-label="Read full answer" data-question="' + question + '">' +
                   '<div class="cta-text">Read full answer</div>' +
                   '<div class="cta-icon"></div>' +
               '</div>' +
           '</div>';
}

// Full CAQ carousel markup (the inner .container): header, slider arrows, the card
// track, and the "Ask your own question" input. Injected into the .caq-wrapper
// once its shimmer is removed; class names match the CAQ stylesheet.
function caqCarouselMarkup(cards) {
    var cardsHtml = (cards || []).map(caqCardMarkup).join('');

    return '<div class="container">' +
               '<div class="caq-header">' +
                   '<div class="icon">' + icons.getIcon('medscapeAi') + '</div>' +
                   '<div class="title">Commonly Asked by HCPs</div>' +
               '</div>' +
               '<div class="carousel">' +
                   // Left slider starts hidden (currentIndex 0); the carousel logic
                   // toggles visibility via updateSliders().
                   '<div class="left-slider slider" style="display:none;">' + icons.getIcon('leftArrow') + '</div>' +
                   '<div class="right-slider slider">' + icons.getIcon('rightArrow') + '</div>' +
                   '<div class="carousel-track">' + cardsHtml + '</div>' +
               '</div>' +
               '<div class="ai-input-wrapper">' +
                   '<input type="text" placeholder="Ask your own question" aria-label="Ask your own question" />' +
                   '<span class="icon">' + icons.getIcon('sparkle') + '</span>' +
               '</div>' +
           '</div>';
}

module.exports = {
    caqCarouselMarkup: caqCarouselMarkup,
    caqCardMarkup: caqCardMarkup
};